export function fmtMoney(v: number | string | null | undefined, currency = 'RON'): string {
  const n = typeof v === 'string' ? Number(v) : (v ?? 0)
  return `${n.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`
}

export function fmtDate(v: string | Date | null | undefined): string {
  if (!v) return ''
  const d = typeof v === 'string' ? new Date(v) : v
  if (isNaN(d.getTime())) return String(v)
  return d.toLocaleDateString('ro-RO')
}

export const ORDER_STATUS: Record<number, string> = {
  0: 'anulată',
  1: 'nouă',
  2: 'în lucru',
  3: 'pregătită',
  4: 'finalizată',
  5: 'returnată',
}
